import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { CalculateRateMutationRequest, CalculateRateMutationResponse, CalculateRate400, CalculateRate401, CalculateRate403, CalculateRate404, CalculateRate410, CalculateRate422, CalculateRate429, CalculateRate500 } from "../types/CalculateRate";

/**
 * @link /api/credit-flow-backend/v1/installment/get_calculate-payment-amount
 */

export function useCalculateRate <TData = CalculateRateMutationResponse, TError = CalculateRate400 | CalculateRate401 | CalculateRate403 | CalculateRate404 | CalculateRate410 | CalculateRate422 | CalculateRate429 | CalculateRate500, TVariables = CalculateRateMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/v1/installment/get_calculate-payment-amount`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
